/**
 * User-facing copy for R1 W2: AI edits applied with Undo, and staged
 * suggestions (editor strip + per-document list).
 *
 * PLACEHOLDER until Kapil's hand test. Every string for this feature lives here
 * so a wording change is one edit. AU English; the current user is "You".
 */

/** Applied-edit notice: the edit is in the section and can be undone. */
export const EDIT_APPLIED = 'Updated {heading}'
export const EDIT_UNDO = 'Undo'
export const EDIT_UNDOING = 'Undoing…'
/** Undo worked. */
export const EDIT_UNDONE = 'Change to {heading} undone'
/** Undo refused: the section changed after the AI edit (409 PROPOSAL_SECTION_CHANGED). */
export const EDIT_UNDO_CONFLICT =
  "{heading} changed after this edit, so it wasn't undone. Use version history if you need the earlier text."
/** Undo failed for another reason (network, server). */
export const EDIT_UNDO_FAILED = "Couldn't undo the change to {heading}"
export const EDIT_UNDO_RETRY = 'Try again'
/** Undo refused because the section is gone (404). */
export const EDIT_UNDO_GONE = '{heading} no longer exists, so there is nothing to undo.'
export const EDIT_NOTICE_DISMISS = 'Dismiss'
/** Fallback when the edit's section has no title. */
export const UNTITLED_SECTION = 'this section'

/** Staged suggestion strip: the section changed, so Accept was refused (409 SUGGESTION_OUTDATED). */
export const SUGGESTION_OUTDATED =
  "This section changed after the suggestion was made, so it wasn't applied. The editor shows the current text."
export const SUGGESTION_DISMISS = 'Dismiss suggestion'
/** Accept found the section deleted (404). */
export const SUGGESTION_SECTION_GONE = 'This section no longer exists, so the suggestion was dismissed.'
/** Reject found the suggestion already accepted (409 PROPOSAL_ALREADY_RESOLVED). */
export const SUGGESTION_ALREADY_ACCEPTED = 'This suggestion was already accepted.'
export const SUGGESTION_ACCEPT_FAILED = "Couldn't accept the suggestion. Try again."
export const SUGGESTION_REJECT_FAILED = "Couldn't reject the suggestion. Try again."

/** Per-document suggestion list. */
export const SUGGESTIONS_WAITING_ONE = '1 suggestion waiting'
export const SUGGESTIONS_WAITING_MANY = '{count} suggestions waiting'
export const SUGGESTION_OPEN = 'Review'
export const SUGGESTION_SHOWING = 'Showing'

export function fillCopy(template: string, values: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => values[key] ?? match)
}
